const URL_SENTENCE_BOUNDARY_CHARS = /[<>"`、。，｡！？；：）］】｝〕〉》」』]/u;

/**
 * 文脈上 URL とみなさない境界文字（空白や句読点など）を含むか判定する。
 * 自動リンク化の誤爆補正は、この境界があるケースに限定して適用する。
 */
export function hasAutolinkSentenceBoundary(raw: string): boolean {
  return URL_SENTENCE_BOUNDARY_CHARS.exec(raw)?.index !== undefined;
}

function countChar(text: string, target: string): number {
  return [...text].filter((char) => char === target).length;
}

function shouldTrimTrailingChar(url: string, trailingChar: string): boolean {
  if ([".", ",", "!", "?", ";", ":"].includes(trailingChar)) {
    return true;
  }

  if (trailingChar === ")") {
    return countChar(url, ")") > countChar(url, "(");
  }
  if (trailingChar === "]") {
    return countChar(url, "]") > countChar(url, "[");
  }
  if (trailingChar === "}") {
    return countChar(url, "}") > countChar(url, "{");
  }

  return false;
}

/**
 * 自動リンク化されたURLから、文脈上URLに含めるべきでない末尾を切り出す。
 * 例: `https://ja.dev/sitemap.xml、サンプリング数` -> URL + `、サンプリング数`
 */
export function splitAutolinkAndSuffix(raw: string): {
  url: string;
  suffix: string;
} {
  let url = raw;
  let suffix = "";

  const boundaryMatch = URL_SENTENCE_BOUNDARY_CHARS.exec(raw);
  if (boundaryMatch?.index !== undefined) {
    url = raw.slice(0, boundaryMatch.index);
    suffix = raw.slice(boundaryMatch.index);
  }

  while (url.length > 0) {
    const trailingChar = url.at(-1);
    if (!trailingChar || !shouldTrimTrailingChar(url, trailingChar)) {
      break;
    }

    url = url.slice(0, -1);
    suffix = `${trailingChar}${suffix}`;
  }

  return { url, suffix };
}
